import React from 'react';
import { Link } from 'react-router-dom';
import SubNavbar from '../../components/SubNavbar';
import ContactBox from '../../components/ContactBox';

const Photography = () => {
  return (
    <div className="white-page">
      <SubNavbar />
      <ContactBox />
      
      <div className="page-content-wrapper">
        <div className="photo-collections">
          <Link to="/photography/italy-greece" className="photo-location">
            <span className="blog-arrow">→</span> <span className="blog-content">Italy & Greece</span>
          </Link>
          <Link to="/photography/bay-area" className="photo-location">
            <span className="blog-arrow">→</span> <span className="blog-content">Bay Area</span>
          </Link>
          <Link to="/photography/us-various" className="photo-location">
            <span className="blog-arrow">→</span> <span className="blog-content">US (Various)</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Photography;
